import { Upload, UploadProps, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { StorageError } from "firebase/storage";
import { upload } from "../../../data/firestore/storage";
import { Id } from "../../../data/types";

const { Dragger } = Upload;

interface Props {
  imageId: Id;
  setUrl: (url: string | undefined) => void;
}

export default function UploadBox({ imageId, setUrl }: Props) {
  const [messageApi, contextHolder] = message.useMessage();
  const props: UploadProps = {
    name: "file",
    multiple: false,
    onChange(info) {
      const { status } = info.file;
      if (status === "done") {
        messageApi.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        messageApi.error(`File upload failed.`);
      }
    },
    async customRequest(options) {
      setUrl(undefined);
      try {
        const url: string = await upload(
          options.file as Blob,
          imageId,
          (percent: number) => {
            options.onProgress!({ percent });
          },
        );
        setUrl(url);
        options.onSuccess!(url);
      } catch (e) {
        options.onError!(e as StorageError);
      }
    },
  };
  return (
    <Dragger {...props}>
      {contextHolder}
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag image here to upload</p>
      <p className="ant-upload-hint"></p>
    </Dragger>
  );
}
